
document.addEventListener("DOMContentLoaded", function () {
  const builder = document.querySelector("#builderRoot");
  if (!builder) return;

  const fitments = window.GT_FITMENTS || [];
  const assets = window.GT_ASSET_MAP || {};
  const products = window.GT_PRODUCTS || {};
  const sizePrices = window.GT_SIZE_PRICES || {};
  const $ = s => document.querySelector(s);
  const $$ = s => Array.from(document.querySelectorAll(s));
  const CART_QUANTITY = parseInt(builder.dataset.cartQuantity || "4", 10) || 4;

  const params = new URLSearchParams(window.location.search);
  const requestedWheel = params.get("wheel") || "GT-01";

  const state = {
    wheel: products[requestedWheel] ? requestedWheel : "GT-01",
    price: (sizePrices[requestedWheel] || sizePrices["GT-01"] || {})[19] || 1125,
    finish: "Bronze",
    sheen: "Satin",
    material: "Forged 6061-T6 Aluminum",
    fitmentRows: [],
    selectedFront: "",
    selectedRear: "",
    selectedBolt: "",
    selectedBore: "",
    centerStyle: false
    ,
    twoPiece: false
  };

  const boot = $("#wheelImage")?.getAttribute("src") || "";
  const assetBase = boot.substring(0, boot.lastIndexOf("/") + 1);
  Object.keys(assets).forEach(model => {
    Object.keys(assets[model]).forEach(finish => {
      const value = assets[model][finish];
      assets[model][finish] = /^https?:\/\//i.test(value) ? value : assetBase + value;
    });
  });

  const money = n => "$" + Math.round(n).toLocaleString();
  const unique = arr => Array.from(new Set(arr.filter(Boolean))).sort((a, b) => String(a).localeCompare(String(b), undefined, { numeric: true }));
  const isCenterLockRows = rows => Array.isArray(rows) && rows.some(r => String(r.boltPattern).toLowerCase().includes("center"));
  const currentFitmentIsCenterLock = () => isCenterLockRows(state.fitmentRows);

  function setWheel(wheel) {
    if (wheel === "GT-01C" && state.fitmentRows.length && !currentFitmentIsCenterLock()) {
      alert("GT-01C is only available for native center-lock vehicles. Select a center-lock fitment to build GT-01C.");
      wheel = "GT-01";
    }
    if (products[wheel]) {
      state.wheel = wheel;
      state.price = (sizePrices[wheel] || sizePrices["GT-01"] || {})[19] || 1125;
      const quick = $("#quickWheel");
      if (quick) quick.value = wheel;
      history.replaceState(null, "", "/pages/wheel-builder?wheel=" + encodeURIComponent(wheel));
      updateAll();
    }
  }

  // Only offer finishes that have a render for the current wheel; if the active
  // finish disappears (e.g. switching to a wheel with no Red render) fall back.
  function refreshSwatches() {
    const wheelAssets = assets[state.wheel] || {};
    let activeMissing = false;
    $$(".gt-swatch").forEach(button => {
      const has = !!wheelAssets[button.dataset.finish];
      button.hidden = !has;
      if (!has && button.dataset.finish === state.finish) activeMissing = true;
    });
    if (activeMissing) {
      const fallback = wheelAssets["Bronze"] ? "Bronze" : Object.keys(wheelAssets)[0];
      if (fallback) {
        state.finish = fallback;
        $$(".gt-swatch").forEach(x => x.classList.toggle("active", x.dataset.finish === fallback));
      }
    }
  }

  function updateWheel() {
    refreshSwatches();
    const img = $("#wheelImage");
    const wheelAssets = assets[state.wheel] || {};
    let src = wheelAssets[state.finish];
    if (!src || src.indexOf("placeholder") !== -1) {
      src = wheelAssets["Bronze"] || Object.values(wheelAssets)[0];
    }
    if (img && src) {
      img.classList.add("is-changing");
      img.src = src;
      setTimeout(() => img.classList.remove("is-changing"), 180);
    }
  }

  function updateProductText() {
    const product = products[state.wheel] || {};
    $("#wheelName").textContent = state.wheel;
    $("#rightWheelName").textContent = state.wheel;
    $("#crumbWheel").textContent = state.wheel;
    $("#wheelSubtitle").textContent = (product.name || "") + " / " + (product.subtitle || "FORGED MONOBLOCK");
    $("#wheelDescription").textContent = product.copy || "Purpose built for the world's finest machines.";
  }

  function updateCenterStyleAvailability() {
    const wrap = $("#centerStyleWrap"), cb = $("#centerStyle"), help = $("#centerStyleHelp");
    if (!wrap || !cb) return;
    const nativeCL = currentFitmentIsCenterLock();
    const noFit = !state.fitmentRows.length;
    const gt01c = state.wheel === "GT-01C";

    if (noFit) {
      wrap.style.display = "";
      cb.disabled = true;
      cb.checked = false;
      state.centerStyle = false;
      help.textContent = "Select a 5-lug vehicle to add the center-lock style cover.";
      wrap.style.opacity = .65;
    } else if (nativeCL || gt01c) {
      wrap.style.display = "none";
      cb.disabled = true;
      cb.checked = false;
      state.centerStyle = false;
      help.textContent = nativeCL ? "This vehicle is native center-lock, so this cosmetic package is not needed." : "GT-01C is already a native center-lock wheel.";
      wrap.style.opacity = .65;
    } else {
      wrap.style.display = "";
      cb.disabled = false;
      help.textContent = "Available for 5-lug vehicles. Adds a cosmetic center-lock style cover over the lug area.";
      wrap.style.opacity = 1;
    }
  }

  function priceForSize(sizeStr) {
    const s = parseSize(sizeStr);
    const modelPrices = sizePrices[state.wheel] || sizePrices["GT-01"] || {};
    let base = modelPrices[s.diameter] || modelPrices[19] || 1125;
    
    let surcharge = 0;
    if (s.width >= 11 && s.width < 12) surcharge = 50;
    else if (s.width >= 12 && s.width < 13) surcharge = 150;
    else if (s.width >= 13 && s.width < 14) surcharge = 250;
    
    return base + surcharge;
  }

  function calc() {
    let fPrice = priceForSize(state.selectedFront);
    let rPrice = priceForSize(state.selectedRear);

    if (state.material.includes("Magnesium")) { fPrice += 1000; rPrice += 1000; }
    if (state.centerStyle) { fPrice += 100; rPrice += 100; }
    if (state.twoPiece) { fPrice += 1000; rPrice += 1000; }

    let setTotal = (fPrice * 2) + (rPrice * 2);
    let avgPrice = setTotal / 4;

    return { avgPrice, setTotal, fPrice, rPrice };
  }

  function updateSummary() {
    const summary = $("#summary"), pEl = $("#price"), setEl = $("#setPrice");
    if (!summary || !pEl || !setEl) return;

    updateCenterStyleAvailability();

    const prices = calc();
    pEl.textContent = `$${Math.round(prices.avgPrice).toLocaleString()} per wheel`;
    setEl.textContent = `$${Math.round(prices.setTotal).toLocaleString()}`;

    const v = state.fitmentRows[0];

    $("#summary").innerHTML =
      "<strong>" + state.wheel + "</strong><br>" +
      "Finish: " + state.sheen + " " + state.finish + "<br>" +
      state.material + "<br>" +
      (v ? (
        v.brand + " " + v.model + " " + v.generation + " " + v.submodel +
        "<br>Front: " + (state.selectedFront || "—") +
        "<br>Rear: " + (state.selectedRear || "—") +
        "<br>Bolt Pattern: " + (state.selectedBolt || "Auto from selected vehicle") +
        "<br>Center Bore: " + (state.selectedBore || "—") + "mm"
      ) : "Select vehicle for confirmed fitment. Bolt pattern will appear here automatically.") +
      (state.wheel === "GT-01C" ? "<br>Native center-lock only wheel." : "") +
      (state.centerStyle ? "<br>Center Lock Style Package added." : "") +
      (state.twoPiece ? "<br>Two-Piece Forged Package added." : "");
  }

  function updateAll() {
    updateProductText();
    updateWheel();
    updateSummary();
  }

  function parseSize(sizeStr) {
    if (!sizeStr || sizeStr.includes("Select") || sizeStr === "Not selected") return { diameter: 19, width: 9 };
    const match = sizeStr.match(/([\d\.]+)[^\d]*x[^\d]*([\d\.]+)/i);
    if (match) {
      const a = parseFloat(match[1]);
      const b = parseFloat(match[2]);
      let diameter = 19;
      let width = 9;
      if (a >= 17 && a <= 24) {
        diameter = a;
        width = b;
      } else if (b >= 17 && b <= 24) {
        diameter = b;
        width = a;
      }
      return { diameter, width };
    }
    return { diameter: 19, width: 9 };
  }

  function updateSizeDropdowns(rows) {
    state.fitmentRows = rows || [];
    const setup = $("#setup"), front = $("#frontSize"), rear = $("#rearSize");
    if(setup) setup.innerHTML = "";
    if(front) front.innerHTML = "";
    if(rear) rear.innerHTML = "";

    if (!rows.length) {
      if(setup) setup.append(new Option("Select vehicle first", ""));
      if(front) front.append(new Option("Select vehicle first", ""));
      if(rear) rear.append(new Option("Select vehicle first", ""));
      state.selectedFront = "";
      state.selectedRear = "";
      state.selectedBolt = "";
      state.selectedBore = "";
      state.selectedSetup = "";
      updateSummary();
      return;
    }

    unique(rows.map(r => r.setup || "Recommended Fitment")).forEach(v => {
      if(setup) setup.append(new Option(v, v));
    });
    if(setup) setup.append(new Option("Custom Fitment", "custom"));
    if(setup) state.selectedSetup = setup.value;

    syncFrontRearOptionsFromSetup();
  }

  function syncFrontRearOptionsFromSetup() {
    const setup = $("#setup"), front = $("#frontSize"), rear = $("#rearSize");
    const rows = state.fitmentRows;
    const val = setup ? setup.value : "";
    
    if(front) front.innerHTML = "";
    if(rear) rear.innerHTML = "";

    let applicableRows = rows;
    
    if (val === "custom") {
      applicableRows = rows;
    } else {
      applicableRows = rows.filter(r => (r.setup || "Recommended Fitment") === val);
    }

    let frontSizes = [];
    let rearSizes = [];
    
    applicableRows.forEach(r => {
      r.front.split(/ or /i).forEach(s => frontSizes.push(s.trim()));
      r.rear.split(/ or /i).forEach(s => rearSizes.push(s.trim()));
    });

    unique(frontSizes).forEach(v => { if(front) front.append(new Option(v, v)); });
    unique(rearSizes).forEach(v => { if(rear) rear.append(new Option(v, v)); });

    if(front) state.selectedFront = front.value;
    if(rear) state.selectedRear = rear.value;
    syncBoltFromSelectedPair(val === "custom");
  }

  function syncBoltFromSelectedPair(isCustom) {
    if (isCustom) {
      const baseRow = state.fitmentRows[0];
      if (baseRow) {
        state.selectedBolt = baseRow.boltPattern;
        state.selectedBore = baseRow.centerBore;
      }
    } else {
      const row = state.fitmentRows.find(r => r.front.includes(state.selectedFront) && r.rear.includes(state.selectedRear)) || state.fitmentRows[0];
      if (row) {
        state.selectedBolt = row.boltPattern;
        state.selectedBore = row.centerBore;
      }
    }
    updateSummary();
  }

  function enforceCenterLockWheel() {
    if (state.wheel === "GT-01C" && state.fitmentRows.length && !currentFitmentIsCenterLock()) {
      alert("GT-01C is center-lock only. This fitment is not center-lock, so the builder switched back to GT-01.");
      state.wheel = "GT-01";
      state.price = (sizePrices["GT-01"] || {})[19] || 1125;
      const quick = $("#quickWheel");
      if (quick) quick.value = state.wheel;
      updateAll();
    }
  }

  function initFitment() {
    const year = $("#year"), brand = $("#brand"), model = $("#model"), submodel = $("#submodel"), card = $("#fitCard"), front = $("#frontSize"), rear = $("#rearSize"), setup = $("#setup");
    function reset(el, label) { el.innerHTML = ""; el.append(new Option(label, "")); }
    function matchesYear(f, yv) {
      if (!yv) return true;
      const y = parseInt(yv, 10);
      return y >= Number(f.yearStart) && y <= Number(f.yearEnd);
    }

    const years = [];
    fitments.forEach(f => {
      for (let y = Number(f.yearStart); y <= Number(f.yearEnd); y++) years.push(y);
    });
    unique(years).sort((a, b) => b - a).forEach(v => year.append(new Option(String(v), String(v))));

    year.addEventListener("change", () => {
      reset(brand, "Brand"); reset(model, "Model"); reset(submodel, "Sub-Model");
      unique(fitments.filter(f => matchesYear(f, year.value)).map(f => f.brand)).forEach(v => brand.append(new Option(v, v)));
      card.innerHTML = '<div class="gt-confirm">Fitment Lookup</div><p>Select brand, model, and sub-model.</p>';
      updateSizeDropdowns([]);
    });

    brand.addEventListener("change", () => {
      reset(model, "Model"); reset(submodel, "Sub-Model");
      unique(fitments.filter(f => matchesYear(f, year.value) && f.brand === brand.value).map(f => f.model)).forEach(v => model.append(new Option(v, v)));
      updateSizeDropdowns([]);
    });

    model.addEventListener("change", () => {
      reset(submodel, "Sub-Model");
      unique(fitments.filter(f => matchesYear(f, year.value) && f.brand === brand.value && f.model === model.value).map(f => f.generation + " — " + f.submodel)).forEach(v => submodel.append(new Option(v, v)));
      updateSizeDropdowns([]);
    });

    submodel.addEventListener("change", () => {
      const rows = fitments.filter(f => matchesYear(f, year.value) && f.brand === brand.value && f.model === model.value && (f.generation + " — " + f.submodel) === submodel.value);
      updateSizeDropdowns(rows);
      enforceCenterLockWheel();
      const first = rows[0];
      const guideLink = $("#fitmentGuideLink");
      if (first) {
        card.innerHTML =
          '<div class="gt-confirm">✓ Fitment confirmed</div>' +
          '<p><strong>' + year.value + ' ' + first.brand + ' ' + first.model + '</strong><br>' +
          first.generation + ' ' + first.submodel + '</p><hr>' +
          '<p>Use the front and rear dropdowns to choose your exact wheel sizes.</p>';
          
        if (guideLink && first.guideUrl) {
          guideLink.href = first.guideUrl;
          guideLink.textContent = `View our fitment guide for the ${first.brand} ${first.model}`;
        }
        checkQuickShip(first);
      } else {
        $("#quickShipAlert")?.classList.remove("is-visible");
        if (guideLink) {
          guideLink.href = "/pages/fitment-guides";
          guideLink.textContent = "View our Fitment Guides";
        }
      }
    });

    function checkQuickShip(vehicle) {
      const qsItems = window.GT_QUICK_SHIP || [];
      const alertBox = $("#quickShipAlert");
      const alertLink = $("#quickShipLink");
      if (!alertBox || !alertLink) return;

      const searchStrings = [
        vehicle.submodel.toLowerCase(),          // e.g. "gt3 rs"
        vehicle.generation.toLowerCase(),        // e.g. "992"
        (vehicle.generation + " " + vehicle.submodel).toLowerCase(), // "992 gt3 rs"
        (vehicle.brand + " " + vehicle.model).toLowerCase()          // "porsche 911"
      ];

      const match = qsItems.find(item => {
        const itemText = (item.title + " " + item.tags.join(" ")).toLowerCase();
        // If the item title or tags contain any of the search strings, it's a match
        return searchStrings.some(str => str.length > 3 && itemText.includes(str));
      });

      if (match) {
        alertLink.href = match.url;
        alertBox.classList.add("is-visible");
      } else {
        alertBox.classList.remove("is-visible");
      }
    }

    if (setup) {
      setup.addEventListener("change", () => {
        state.selectedSetup = setup.value;
        syncFrontRearOptionsFromSetup();
      });
    }

    front.addEventListener("change", () => {
      state.selectedFront = front.value;
      syncBoltFromSelectedPair(setup && setup.value === "custom");
    });

    rear.addEventListener("change", () => {
      state.selectedRear = rear.value;
      syncBoltFromSelectedPair(setup && setup.value === "custom");
    });
  
    // Deep links from the fitment guides: ?brand=&model=&sub=[&year=]
    const qs = new URLSearchParams(window.location.search);
    if (qs.get("brand")) {
      const pick = (el, value) => { if (!value) return false; const opt = Array.from(el.options).find(o => o.value === value || o.value.toLowerCase() === value.toLowerCase()); if (!opt) return false; el.value = opt.value; el.dispatchEvent(new Event("change")); return true; };
      const wantYear = qs.get("year");
      const yearOpt = wantYear && Array.from(year.options).find(o => o.value === wantYear);
      if (yearOpt) { pick(year, wantYear); } else {
        const wantSub = (qs.get("sub") || "").toLowerCase();
        const rows = fitments.filter(f => f.brand.toLowerCase() === qs.get("brand").toLowerCase() && (!qs.get("model") || f.model.toLowerCase() === qs.get("model").toLowerCase()) && (!wantSub || (f.generation + " — " + f.submodel).toLowerCase() === wantSub));
        const latest = rows.length ? Math.max(...rows.map(f => Number(f.yearEnd))) : null;
        if (latest) pick(year, String(latest));
      }
      pick(brand, qs.get("brand"));
      pick(model, qs.get("model"));
      if (qs.get("sub")) {
        const want = qs.get("sub").toLowerCase();
        const opt = Array.from(submodel.options).find(o => o.value.toLowerCase() === want) || Array.from(submodel.options).find(o => o.value.toLowerCase().includes(want.split(" — ").pop()));
        if (opt) { submodel.value = opt.value; submodel.dispatchEvent(new Event("change")); }
      }
      const left = document.querySelector(".builder-left");
      if (left && window.innerWidth < 980) left.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  function buildPackageOptionValue() {
    if (state.wheel === "GT-01C") {
      return state.twoPiece ? "Native Center Lock + Two-Piece" : "Native Center Lock";
    }
    if (state.centerStyle && state.twoPiece) return "Center Lock Style + Two-Piece";
    if (state.centerStyle) return "Center Lock Style";
    if (state.twoPiece) return "Two-Piece";
    return "Standard";
  }

  function materialOptionValue() {
    return state.material.includes("Magnesium") ? "Forged Magnesium" : "Forged 6061-T6 Aluminum";
  }

  async function fetchWheelProduct() {
    const product = products[state.wheel] || {};
    const handle = product.productHandle;
    if (!handle) throw new Error("Missing product handle for " + state.wheel + ".");
    const response = await fetch("/products/" + handle + ".js", { headers: { "Accept": "application/json" } });
    if (!response.ok) {
      throw new Error("Product " + handle + " was not found. Import the provided Shopify products CSV first, then make sure the products are active in Online Store.");
    }
    return await response.json();
  }

  function findVariantBySize(product, diameter, width) {
    const dStr = String(diameter);
    const wStr = width % 1 === 0 ? width + ".0" : String(width);
    const match = (product.variants || []).find(v =>
      String(v.option1) === dStr &&
      (String(v.option2) === wStr || String(v.option2) === String(width)) &&
      v.available !== false
    );
    if (!match) {
      throw new Error("No variant found for " + state.wheel + " in size " + dStr + "x" + wStr + ". Make sure the product has a variant for this size.");
    }
    return match;
  }

  function buildCartProperties(position, sizeStr) {
    const product = products[state.wheel] || {};
    const vehicle = state.fitmentRows[0];
    return {
      "Wheel Model": state.wheel,
      "Wheel Name": product.name || "",
      "Position": position,
      "Wheel Size": sizeStr || "Not selected",
      "Finish": state.sheen + " " + state.finish,
      "Material": materialOptionValue(),
      "Vehicle": vehicle ? (vehicle.brand + " " + vehicle.model + " " + vehicle.generation + " " + vehicle.submodel) : "Not selected",
      "Bolt Pattern": state.selectedBolt || "Auto from selected vehicle",
      "Center Bore": state.selectedBore ? state.selectedBore + "mm" : "Auto from selected vehicle",
      "Center Lock Style": state.centerStyle ? "Yes" : (state.wheel === "GT-01C" ? "Native" : "No"),
      "Two-Piece Forged": state.twoPiece ? "Yes" : "No"
    };
  }

  async function addBuildToCart() {
    const notice = $("#cartNotice");
    if (notice) notice.textContent = "";
    if (!state.selectedFront || !state.selectedRear) {
      if (notice) notice.textContent = "Select a vehicle plus front and rear wheel sizes before adding to cart.";
      return;
    }
    const button = $("#addToCart");
    if (button) button.textContent = "Adding...";
    try {
      const product = await fetchWheelProduct();
      const fSize = parseSize(state.selectedFront);
      const rSize = parseSize(state.selectedRear);
      const items = [];

      if (fSize.diameter === rSize.diameter && fSize.width === rSize.width) {
        // Square setup — one line item, qty = CART_QUANTITY
        const variant = findVariantBySize(product, fSize.diameter, fSize.width);
        items.push({
          id: Number(variant.id),
          quantity: CART_QUANTITY,
          properties: buildCartProperties("Front & Rear", state.selectedFront + (state.selectedFront !== state.selectedRear ? " / " + state.selectedRear : ""))
        });
      } else {
        // Staggered — two line items, 2x front + 2x rear
        const fVariant = findVariantBySize(product, fSize.diameter, fSize.width);
        const rVariant = findVariantBySize(product, rSize.diameter, rSize.width);
        items.push({
          id: Number(fVariant.id),
          quantity: 2,
          properties: buildCartProperties("Front", state.selectedFront)
        });
        items.push({
          id: Number(rVariant.id),
          quantity: 2,
          properties: buildCartProperties("Rear", state.selectedRear)
        });
      }

      // Helper to silently fetch an add-on product
      async function fetchAddon(handle) {
        try {
          const res = await fetch("/products/" + handle + ".js", { headers: { "Accept": "application/json" } });
          if (res.ok) return await res.json();
        } catch (e) {}
        return null;
      }

      // Add Magnesium Upgrade
      if (state.material.includes("Magnesium")) {
        const addon = await fetchAddon("magnesium-forged-upgrade");
        if (addon && addon.variants[0]) {
          items.push({
            id: Number(addon.variants[0].id),
            quantity: CART_QUANTITY,
            properties: { "Applies To": state.wheel + " Build" }
          });
        }
      }

      // Add Center Lock Style Package
      if (state.centerStyle) {
        const addon = await fetchAddon("center-lock-style-package");
        if (addon && addon.variants[0]) {
          items.push({
            id: Number(addon.variants[0].id),
            quantity: CART_QUANTITY,
            properties: { "Applies To": state.wheel + " Build" }
          });
        }
      }

      // Add Two-Piece Forged Upgrade
      if (state.twoPiece) {
        const addon = await fetchAddon("two-piece-forged-package");
        if (addon && addon.variants[0]) {
          items.push({
            id: Number(addon.variants[0].id),
            quantity: CART_QUANTITY,
            properties: { "Applies To": state.wheel + " Build" }
          });
        }
      }

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items })
      });
      if (!response.ok) {
        const error = await response.json().catch(() => ({ description: "Could not add this build to cart." }));
        throw new Error(error.description || error.message || "Could not add this build to cart.");
      }
      window.location.href = "/cart";
    } catch (err) {
      if (notice) notice.textContent = err.message;
      if (button) button.textContent = "Add Build To Cart";
    }
  }

  $$(".gt-swatch").forEach(button => {
    button.addEventListener("click", () => {
      $$(".gt-swatch").forEach(x => x.classList.remove("active"));
      button.classList.add("active");
      state.finish = button.dataset.finish;
      updateAll();
    });
  });

  $$(".gt-sheen-toggle button").forEach(button => {
    button.addEventListener("click", () => {
      $$(".gt-sheen-toggle button").forEach(x => x.classList.remove("active"));
      button.classList.add("active");
      state.sheen = button.dataset.sheen;
      updateAll();
    });
  });

  $("#quickWheel").addEventListener("change", e => setWheel(e.target.value));
  $("#material").addEventListener("change", e => { state.material = e.target.value; updateSummary(); });
  $("#centerStyle").addEventListener("change", e => { state.centerStyle = e.target.checked && !e.target.disabled; updateSummary(); });
  $("#twoPiece").addEventListener("change", e => { state.twoPiece = e.target.checked; updateWheel(); updateSummary(); });
  $("#addToCart").addEventListener("click", addBuildToCart);

  initFitment();
  const menuToggle = document.querySelector('.gt-menu-toggle');
  if (menuToggle) { menuToggle.addEventListener('click', () => { document.querySelector('.gt-header').classList.toggle('mobile-open'); }); }
  updateAll();
});
